import {
  FC,
  useRef,
  useCallback,
  useState,
  useEffect,
  useContext,
} from "react";
import useAuth from "src/hooks/use-auth";
import { useNavigate } from "react-router-dom";
import Button from "../ui/button";
import { QuestionIcon } from "../icons/question-icon";
import GlobalContext from "src/context/global-context";
import routes from "src/config/routes";

export const Enable2FaBanner: FC = () => {
  const navigate = useNavigate();
  const { getCurrrentUser } = useAuth();

  const onStartVerification = () => {
    navigate("/profile/2fa");
  };
  return (
    <div className="hidden sm:flex top-[70px] z-30 h-[51px] w-full items-center justify-center gap-2 bg-[#FFF5E7]">
      <QuestionIcon className="w-[19px] h-[19px] text-primary" />
      <p className="text-[14px] font-manrope font-medium leading-[21px] text-primary">
        Please Enable 2Fa
      </p>
      <Button
        onClick={onStartVerification}
        variant="solidDanger"
        type="submit"
        className={`${"w-[101px]"} rounded-[8px] font-manrope text-[14px] font-medium leading-[21px]`}
      >
        Enable 2FA
      </Button>
    </div>
  );
};

//   export const MobileVerificationBanner: FC = () => {
//     const navigate = useNavigate();
//     const { language } = useContext(GlobalContext);
//     const { getCurrrentUser } = useAuth();

//     const onStartVerification = () => {
//       navigate(
//         !!getCurrrentUser()?.is_business ? routes.kycBuisiness : routes.kyc
//       );
//     };
//     return (
//       <div className="flex sticky top-16 sm:top-[70px] z-10 sm:hidden w-full items-center justify-center gap-2 bg-[#FFF5E7] p-2">
//         <QuestionIcon className="w-[15px] h-[15px] text-primary flex-shrink-0" />
//         <p className="text-[12px] sm:text-[14px] font-manrope font-medium leading-[21px] text-primary">
//           {String(L.translate("Deposit.protect_your_funds"))}
//         </p>
//         <Button
//           onClick={onStartVerification}
//           variant="solidDanger"
//           type="submit"
//           className={`${
//             language === "EN" ? "w-[101px]" : "w-[136px]"
//           } rounded-[8px] font-manrope text-[14px] font-medium leading-[21px] flex-shrink-0`}
//         >
//           {String(L.translate("Deposit.verify_now"))}
//         </Button>
//       </div>
//     );
//   };
